var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5"},[_c(_vm.getControlComponent,{tag:"component",attrs:{"vars":_vm.getVars,"actors":_vm.actors,"defaultValue":_vm.getDefaultValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }